import { Component, OnInit } from "@angular/core";
import { ContactInquiryService } from "../../services/contact-inquiry.service";
import { ActivatedRoute } from "@angular/router";
import AppConstants from "../../constants/AppConstants";

@Component({
  selector: "app-contact-inquiries",
  templateUrl: "./contact-inquiries.component.html",
  styleUrls: ["./contact-inquiries.component.scss"],
})
export class ContactInquiriesComponent {
  count: number;
  inquiries = [];
  searchQuery = "";
  readonly DEFAULT_PAGE_SIZE = AppConstants.DEFAULT_PAGE_SIZE;
  readonly DEFAULT_PAGE_SIZE_OPTIONS = AppConstants.DEFAULT_PAGE_SIZE_OPTIONS;
  readonly DEFAULT_PAGINATION_INFO = { pageIndex: 0, pageSize: 10 };
  pageIndex = 0;
  pageCursors: any[] = [];
  currentPageSize = 10;

  constructor(
    private graphqlService: ContactInquiryService,
    private route: ActivatedRoute,
  ) {
    route.params.subscribe((val) => {
      this.fetchList(this.DEFAULT_PAGINATION_INFO);
    });
  }

  pageChanged({ pageIndex, pageSize }) {
    this.fetchList(
      {
        pageIndex,
        pageSize,
      },
      this.searchQuery,
    );
  }

  search(input) {
    this.pageIndex = 0;
    this.pageCursors = [];
    this.fetchList({ pageIndex: 0, pageSize: this.currentPageSize }, input);
  }

  private fetchList(pageInfo, searchParam?: string) {
    this.pageIndex = pageInfo.pageIndex;
    const cursorForPage = this.pageIndex > 0 ? this.pageCursors[this.pageIndex - 1] : undefined;
    const obj = {
      paginationData: {
        pageIndex: pageInfo.pageIndex,
        pageSize: pageInfo.pageSize,
        next: cursorForPage,
      },
      searchParam: searchParam,
    };
    this.graphqlService.list(obj).subscribe((result) => {
      if (result && result.data) {
        this.inquiries = result.data["contactInquiries"].edges.map((edge) => edge.node);
        this.count = result.data["contactInquiries"].totalCount;
        this.pageCursors[this.pageIndex] = result.data["contactInquiries"].pageInfo;
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/contact-inquiries/contact-inquiries.component.ts